import { t } from 'i18next'

import { SelecaoProdutoPropostaValidadorBase } from '@/features/simulacao/utils/selecao-produto-proposta-validador-base'

export class SelecaoAcessorioPropostaValidador extends SelecaoProdutoPropostaValidadorBase {
  private existeUmaSimulacaoDaUnidadeSelecionada(): boolean {
    return (
      !!this.simulacoes.filter((simulacao) => simulacao.tipoDoProduto === 'Unidade').length &&
      this.simulacaoSelecionada.tipoDoProduto === 'Unidade'
    )
  }

  private acessorioSelecionadoSemUnidade(): boolean {
    const possuiProdutoUnidade = this.simulacoes.some((s) => s.tipoDoProduto === 'Unidade')
    return this.simulacaoSelecionada.tipoDoProduto === 'Acessorio' && !possuiProdutoUnidade
  }

  private existemAcessoriosSemUnidade(): boolean {
    const possuiProdutoUnidade = this.simulacoes.some((s) => s.tipoDoProduto === 'Unidade')
    const possuiAcessoriosExtra = this.simulacoes.some((s) => s.tipoDoProduto === 'Acessorio')

    return !possuiProdutoUnidade && possuiAcessoriosExtra
  }

  validate() {
    if (this.existeMaisDeUmaSimulacaoDoProdutoSelecionada()) {
      return t('proposta:selecao_produto.erros.produto_duplicado', { tipoProduto: this.textoDinamicoTipoProduto })
    }
    if (this.existeUmaSimulacaoDaUnidadeSelecionada()) {
      return t('proposta:selecao_produto.erros.maximo_unidades')
    }

    if (this.acessorioSelecionadoSemUnidade()) {
      return t('proposta:selecao_produto.erros.acessorio_sem_unidade')
    }

    if (this.existemAcessoriosSemUnidade()) {
      return t('proposta:selecao_produto.erros.deselecao_unidade')
    }

    if (this.simulacaoSelecionadaPossuiParcelaVencida()) {
      return t('proposta:selecao_produto.erros.parcelas_vencidas')
    }
    return null
  }
}
